import { createFileRoute } from '@tanstack/react-router';
import { PurchaseCreationPage } from '@/features/purchases/components/PurchaseCreationPage';

export const Route = createFileRoute('/$commiteeSlug/orders/create')({
  component: PurchaseCreationPage,
});
